// Webpack Imports
import * as bootstrap from 'bootstrap';

(function ($) {
    'use strict';

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), (el) => {
        el.addEventListener('submit', function (e) {
            var search = el.querySelector('input');
            if (search.value.length < 1) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });

    // Load more posts via ajax functionality
    class ajaxLoadPosts {
        constructor() {
            this.currentPage = 1;
            this.postsPerPage = null;

            this.theButtonEl = $(".blog-load-more-posts button");

            const that = this;
            that.init()
        }

        init() {
            const that = this;
            that.postsPerPage = that.theButtonEl.data("ppp");
            $(".blog-load-more-posts button").on("click", function (e) {
                e.preventDefault();
                that.loadMorePosts();
            });
        }

        loadMorePosts() {
            const that = this;
            that.currentPage += 1;

            that.theButtonEl.attr("disabled", true);

            var data = {
                action: 'powerpulse_load_more_posts',
                page: that.currentPage,
                ppp: that.postsPerPage
            };

            $.post(frontendajax.ajaxurl, data, function (response) {
                if (response.length > 0) {
                    $(".blog-latest-posts").append(response);
                    that.theButtonEl.attr("disabled", false);
                }
            });


        }
    }

    const ajaxLoadPostsInstanse = new ajaxLoadPosts();

    /**
     * 
     * @type type
     */
    class headerMenu {
        constructor() {
            this.ScrollMagicInstance = new ScrollMagic.Controller();


            const that = this;
            that.init()
        }

        init() {
            const that = this;

            // build scene
            var scene = new ScrollMagic.Scene({offset: 1})
                    .setClassToggle("#navbar", "scrolled") // add class toggle
                    .addTo(that.ScrollMagicInstance)
//                    .addIndicators() // add indicators (requires plugin)

            that.contactUsButtonHandler();
        }

        contactUsButtonHandler() {
            $('.header-contact-us-btn a').on('click', function (e) {
                setTimeout(function () {
                    window.contactUs.openMenu();
                }
                , 100)
            });
        }
    }

    var headerMenuInstance = new headerMenu();

    function viewportToPixels(value) {
        var parts = value.match(/([0-9\.]+)(vh|vw)/)
        var q = Number(parts[1])
        var side = window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]]
        return side * (q / 100)
    }

    /*
     * Custom animation class plugin using animate.css
     * 
     * https://animate.style/#javascript
     * 
     * $0.classList.add('animate__animated', 'animate__slideInUp');
     * 
     * waypoint http://imakewebthings.com/waypoints/guides/getting-started/
     * 
     */

    /**
     * Detect and return the current active responsive breakpoint in Bootstrap
     * @returns {string}
     * @author farside {@link https://stackoverflow.com/users/4354249/farside}
     */
    function getResponsiveBreakpoint() {
        var envs = ["xs", "sm", "md", "lg", "xl", "xxl"];
        var env = "";

        var $el = $("<div>");
        $el.appendTo($("body"));

        for (var i = envs.length - 1; i >= 0; i--) {
            env = envs[i];
            $el.addClass("d-" + env + "-none");
            ;
            if ($el.is(":hidden")) {
                break; // env detected
            }
        }
        $el.remove();
        return env;
    }

})(jQuery);
